module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-13.9ef2dbdb.png";